export const EventTickerMessageCategory = {
    Text: 'text',
    Success: 'success',
    Warning: 'warning',
    Danger: 'danger',
};
//# sourceMappingURL=EventTickerMessageCategory.js.map